import { CFAuthGetRef } from 'auth';
import { locations } from "../../common/redux/action_locations";
import moment from "moment-timezone";
import {
	FETCH_TIMEOFF_SUMMARY,
	FETCH_NEXT_ACCRUAL_DATE,
	RECEIVED_NEXT_ACCRUAL_DATE,
	RECEIVED_TIME_OFF_SUMMARY
} from "./constants";

export function fetchTimeOffSummaryAction(filters) {
    return {
        type: FETCH_TIMEOFF_SUMMARY,
        fetchCall: fetchTimeOffSummary,
		receivedAction: receivedTimeOffSummary,
		data: {
			locations,
			filters
		}
    }
}

function fetchTimeOffSummary(filters) {
	return CFAuthGetRef({
		url: process.env.REACT_APP_AP_API_URL + '/TimeoffRequest/Summary/' + filters.agentID,
		params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchTimeOffSummary'
	});
}

export function receivedTimeOffSummary(data) {
	return {
        type: RECEIVED_TIME_OFF_SUMMARY,
        SummaryItems: data
	};
}

export function fetchNextAccrualDateAction(filters) {
    return {
        type: FETCH_NEXT_ACCRUAL_DATE,
        fetchCall: fetchNextAccrualDate,
		receivedAction: receivedNextAccrualDate,
		data: {
			locations,
			filters
        }
    }
}

function fetchNextAccrualDate(filters) {
	return CFAuthGetRef({
		url: process.env.REACT_APP_AP_API_URL + '/TimeoffRequest/Accrued/NextAccruelDate/' + filters.agentID,
		params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchNextAccrualDate'
	});
}

export function receivedNextAccrualDate(data) {
	return {
        type: RECEIVED_NEXT_ACCRUAL_DATE,
        NextAccrualDate: moment(data)
	};
}

export function reducer(state, action) {
	switch (action.type) {
		case RECEIVED_TIME_OFF_SUMMARY:
		return {
            ...state,
            SummaryItems: action.SummaryItems,
        };
		
		case RECEIVED_NEXT_ACCRUAL_DATE:
        return {
            ...state,
            NextAccrualDate: action.NextAccrualDate,
        };
		default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/features/timeoff/redux/time_off_summary_actions.js